(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["depict-patched-main-collection-variants"]) return;
  try {
    
  const VariantsNum = document.querySelectorAll('.grid-product__content');
  const variantCountContainers = document.querySelectorAll('[data-variants-count]');

  variantCountContainers.forEach(container => {
    container.innerHTML = `${VariantsNum.length} products`;
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-variants"]) return;
  try {
    
    const VariantsNum = document.querySelectorAll(".grid-product__content")
    const variantCountContainers = document.querySelectorAll("[data-variants-count]")

    variantCountContainers.forEach(container => {
      container.innerHTML = `${VariantsNum.length} products`
    });
  
  } catch(e) { console.error(e); }
})();
})();
